import { render, staticRenderFns } from "./ModalPlan.vue?vue&type=template&id=ef9b6818&"
import script from "./ModalPlan.vue?vue&type=script&lang=js&"
export * from "./ModalPlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports